enum SaveMode {
	OnClick,
	OnInit,
}

export default SaveMode;
